import React, { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import v4 from 'uuid/v4'

import moment from 'moment'
import CustomScrollView from '../../../UIControls/CustomScrollView'
import TasksHelper, { OPEN_STEP, objectIsPublicForLoggedUser } from '../../../TaskListView/Utils/TasksHelper'
import store from '../../../../redux/store'
import Backend from '../../../../utils/BackendBridge'
import {
    hideFloatPopup,
    setSelectedSidebarTab,
    setSelectedTypeOfProject,
    setTasksArrowButtonIsExpanded,
    showFloatPopup,
    switchProject,
    updateTaskSuggestedCommentModalData,
    hideWebSideBar,
} from '../../../../redux/actions'
import RecurrenceModal from '../RecurrenceModal'
import DueDateModal from '../DueDateModal/DueDateModal'
import {
    FEED_ASSISTANT_OBJECT_TYPE,
    FEED_CHAT_OBJECT_TYPE,
    FEED_CONTACT_OBJECT_TYPE,
    FEED_GOAL_OBJECT_TYPE,
    FEED_NOTE_OBJECT_TYPE,
    FEED_OBJECT_NOTE_OBJECT_TYPE,
    FEED_PROJECT_OBJECT_TYPE,
    FEED_SKILL_OBJECT_TYPE,
    FEED_TASK_OBJECT_TYPE,
    FEED_USER_OBJECT_TYPE,
} from '../../../Feeds/Utils/FeedsConstants'
import ProjectHelper, { checkIfSelectedProject } from '../../../SettingsView/ProjectsSettings/ProjectHelper'
import PrivacyModal from '../PrivacyModal/PrivacyModal'
import AssigneeAndObserversModal from '../AssigneeAndObserversModal/AssigneeAndObserversModal'
import {
    DV_TAB_CHAT_BOARD,
    DV_TAB_CONTACT_CHAT,
    DV_TAB_GOAL_CHAT,
    DV_TAB_NOTE_CHAT,
    DV_TAB_TASK_CHAT,
    DV_TAB_USER_CHAT,
    DV_TAB_SKILL_CHAT,
    DV_TAB_ROOT_TASKS,
    DV_TAB_ASSISTANT_CHAT,
} from '../../../../utils/TabNavigationConstants'
import {
    DATE_TASK_INDEX,
    EMPTY_SECTION_INDEX,
    MAIN_TASK_INDEX,
    NOT_PARENT_GOAL_INDEX,
    TODAY_DATE,
} from '../../../../utils/backends/openTasks'
import MainModal from './MainModal'
import useCreateTaskPopupWidth from './createTaskPopupWidth'
import TaskParentGoalModal from '../TaskParentGoalModal/TaskParentGoalModal'
import TaskMoreOptionModal from '../TaskMoreOptionsModal/TaskMoreOptionModal'
import { isWorkstream, WORKSTREAM_ID_PREFIX } from '../../../Workstreams/WorkstreamHelper'
import { getDvTabLink } from '../../../../utils/LinkingHelper'
import { createTaskWithService } from '../../../../utils/backends/Tasks/TaskServiceFrontendHelper'
import SelectProjectModalInSearch from '../SelectProjectModal/SelectProjectModalInSearch'
import { AUTOMATIC_PROJECT_OPTION, isAutomaticProjectOption } from '../SelectProjectModal/projectPickerConstants'
import { applyProjectSwitchToDraft } from './projectSwitchDraft'
import { buildPendingProjectRouting, resolveAutomaticHostProjectId } from '../../../../utils/automaticProjectRouting'
import {
    addProjectDataToMyDayData,
    processMyDayData,
} from '../../../MyDayView/MyDayTasks/MyDayOpenTasks/myDayOpenTasksHelper'
import { TO_ATTEND_TASKS_MY_DAY_TYPE, WORKSTREAM_TASKS_MY_DAY_TYPE } from '../../../../utils/backends/Tasks/myDayTasks'
import useSingleFlightSubmit from '../../../../hooks/useSingleFlightSubmit'
import { translate } from '../../../../i18n/TranslationService'
import { openDictationTaskRecovery } from './dictationTaskRecovery'

const buildLinkBack = (projectId, sourceType, sourceId, objectNoteType) => {
    const { selectedNavItem } = store.getState()

    const inChatTab =
        selectedNavItem === DV_TAB_TASK_CHAT ||
        selectedNavItem === DV_TAB_CONTACT_CHAT ||
        selectedNavItem === DV_TAB_USER_CHAT ||
        selectedNavItem === DV_TAB_CHAT_BOARD ||
        selectedNavItem === DV_TAB_NOTE_CHAT ||
        selectedNavItem === DV_TAB_SKILL_CHAT ||
        selectedNavItem === DV_TAB_GOAL_CHAT ||
        selectedNavItem === DV_TAB_ASSISTANT_CHAT

    let url = ''
    const tab = inChatTab
        ? 'chat'
        : sourceType === FEED_NOTE_OBJECT_TYPE
          ? 'editor'
          : sourceType === FEED_ASSISTANT_OBJECT_TYPE
            ? 'customizations'
            : 'properties'

    switch (sourceType) {
        case FEED_TASK_OBJECT_TYPE: {
            url = getDvTabLink(projectId, sourceId, 'tasks', tab)
            break
        }
        case FEED_PROJECT_OBJECT_TYPE: {
            url = getDvTabLink(projectId, sourceId, 'projects', 'properties')
            break
        }
        case FEED_CONTACT_OBJECT_TYPE: {
            url = getDvTabLink(projectId, sourceId, 'contacts', tab)
            break
        }
        case FEED_USER_OBJECT_TYPE: {
            url = getDvTabLink(projectId, sourceId, 'users', tab)
            break
        }
        case FEED_NOTE_OBJECT_TYPE: {
            url = getDvTabLink(projectId, sourceId, 'notes', tab)
            break
        }
        case FEED_OBJECT_NOTE_OBJECT_TYPE: {
            url = getDvTabLink(projectId, sourceId, objectNoteType, tab)
            break
        }
        case FEED_GOAL_OBJECT_TYPE: {
            url = getDvTabLink(projectId, sourceId, 'goals', tab)
            break
        }
        case FEED_CHAT_OBJECT_TYPE: {
            url = getDvTabLink(projectId, sourceId, 'chats', tab)
            break
        }
        case FEED_SKILL_OBJECT_TYPE: {
            url = getDvTabLink(projectId, sourceId, 'skills', tab)
            break
        }
        case FEED_ASSISTANT_OBJECT_TYPE: {
            url = getDvTabLink(projectId, sourceId, 'assistants', tab)
            break
        }
    }

    return url
}

const getNewInitialDefaultTask = (
    fromTaskList,
    projectId,
    sourceType,
    sourceId,
    sourceIsPublicFor,
    objectNoteType,
    lockKey,
    useLoggedUser,
    initialTaskName,
    initialDueDate
) => {
    const { loggedUser, currentUser } = store.getState()
    const user = fromTaskList && !useLoggedUser ? currentUser : loggedUser
    const uid = user.uid
    const newTask = TasksHelper.getNewDefaultTask()
    const taskName = fromTaskList
        ? initialTaskName || ''
        : `${window.location.origin}${buildLinkBack(projectId, sourceType, sourceId, objectNoteType)} `
    newTask.name = taskName
    newTask.extendedName = taskName
    newTask.userId = uid
    newTask.currentReviewerId = uid
    newTask.userIds = [uid]
    // AT-2875: a popup opened from a dated inline add-task line (a future day or Someday)
    // creates the task in that line, exactly like the inline editor it replaces would have.
    if (fromTaskList && Number.isFinite(initialDueDate)) newTask.dueDate = initialDueDate
    if (sourceType === FEED_GOAL_OBJECT_TYPE && sourceIsPublicFor) {
        newTask.parentGoalId = sourceId
        newTask.parentGoalIsPublicFor = sourceIsPublicFor
        newTask.lockKey = lockKey ? lockKey : ''
    }
    if (loggedUser.uid !== uid && !user.recorderUserId && !uid.startsWith(WORKSTREAM_ID_PREFIX)) {
        newTask.suggestedBy = loggedUser.uid
    }
    return newTask
}

// The real project an "Automatic" task is created in while the server-side
// router decides where it belongs (AT-2306). Read from the store rather than
// from the modal's own `projects` state because that list is only built when the
// project selector is opened, while the host project is needed at mount.
const getAutomaticHostProjectId = () => {
    const { loggedUser, loggedUserProjects } = store.getState()
    const activeProjects = ProjectHelper.getActiveProjects2(loggedUserProjects, loggedUser)
    return resolveAutomaticHostProjectId({ defaultProjectId: loggedUser.defaultProjectId, projects: activeProjects })
}

export default function RichCreateTaskModal({
    initialProjectId,
    initialTask,
    setShowInteractionBar,
    triggerWhenCreateTask,
    sourceId,
    objectNoteType,
    sourceType,
    sourceIsPublicFor,
    lockKey,
    fromTaskList,
    closeModal,
    setPressedShowMoreMainSection,
    modalTitle,
    tryExpandTasksListInGoalWhenAddTask,
    useLoggedUser,
    // PT-4745: the project switcher is part of the add-task popup at EVERY entry
    // point now, so this defaults to on and no caller passes it. It stays a prop
    // (rather than being deleted) so a future surface that genuinely has no
    // project to switch to can opt out explicitly, and so the two All Projects
    // call sites keep saying out loud that they depend on it.
    showProjectSelector = true,
    expandTaskListIfNeeded,
    initialTaskName,
    // AT-2875: files dropped on the inline "Add new task" line, applied once on mount through
    // the same draft-attachment path as a drop on the popup itself.
    initialFiles,
    initialDueDate,
    // Called once a creation is actually submitted (after any attachment upload succeeded),
    // so the opener can drop the inline draft text it handed over.
    onDraftSubmitted,
    // AT-2823: set when the popup was opened by holding the board's floating "+"; the title
    // input's mic takes that hold over and runs it as an ordinary push-to-talk dictation.
    pushToTalkHandoff,
}) {
    const dispatch = useDispatch()
    // One measurement shared by the form and the in-place project picker, so
    // the popup never changes width between the two steps.
    const widthStyle = useCreateTaskPopupWidth()
    // "Automatic" is a picker option, not a project: the task still needs a real
    // project to be written to, so the sentinel is split here into the flag that
    // asks the server to route it and the host project it is created in.
    const [automaticProject, setAutomaticProject] = useState(() => isAutomaticProjectOption(initialProjectId))
    const [projectId, setProjectId] = useState(() =>
        isAutomaticProjectOption(initialProjectId) ? getAutomaticHostProjectId() : initialProjectId
    )
    const [activeGoal, setActiveGoal] = useState(null)
    const [showDueDateModal, setShowDueDateModal] = useState(false)
    const [showRecurrenceModal, setShowRecurrenceModal] = useState(false)
    const [showPrivacyModal, setShowPrivacyModal] = useState(false)
    const [showAssigneeModal, setShowAssigneeModal] = useState(false)
    const [showParentGoalModal, setShowParentGoalModal] = useState(false)
    const [showMoreOptionsModal, setShowMoreOptionsModal] = useState(false)
    const [showSelectProjectModal, setShowSelectProjectModal] = useState(false)
    const [selectedProject, setSelectedProject] = useState(null)
    const [projects, setProjects] = useState([])
    const [uploadingDraft, setUploadingDraft] = useState(false)
    const droppedObjectUrls = useRef(new Set())

    useEffect(
        () => () => {
            droppedObjectUrls.current.forEach(uri => URL.revokeObjectURL(uri))
        },
        []
    )

    // Enter can reach the creation handlers through several independent
    // listeners at once (see TaskEditForm/ButtonsArea/DoneButton and Quill's
    // newline callback), and closing this popup is asynchronous. Route every
    // creation path of this popup instance through one guard so a double
    // Return, a held Return, or a rapid click can only ever create one task.
    const submitOnce = useSingleFlightSubmit(submission => submission())

    const [task, setTask] = useState(
        initialTask
            ? initialTask
            : getNewInitialDefaultTask(
                  fromTaskList,
                  projectId,
                  sourceType,
                  sourceId,
                  sourceIsPublicFor,
                  objectNoteType,
                  lockKey,
                  useLoggedUser,
                  initialTaskName,
                  initialDueDate
              )
    )

    const showDueDate = () => {
        if (!showDueDateModal) {
            setShowDueDateModal(true)
            dispatch(showFloatPopup())
        }
    }

    const showRecurring = () => {
        if (!showRecurrenceModal) {
            setShowRecurrenceModal(true)
            dispatch(showFloatPopup())
        }
    }

    const showParentGoal = () => {
        if (!showParentGoalModal) {
            setShowParentGoalModal(true)
        }
    }

    const showMoreOptions = () => {
        if (!showMoreOptionsModal) {
            setShowMoreOptionsModal(true)
        }
    }

    const showSelectProject = () => {
        setShowSelectProjectModal(true)
    }

    const showPrivacy = () => {
        if (!showPrivacyModal) {
            setShowPrivacyModal(true)
            dispatch(showFloatPopup())
        }
    }

    const showAssignee = () => {
        if (!showAssigneeModal) {
            setShowAssigneeModal(true)
            store.dispatch(showFloatPopup())
        }
    }

    const saveDescription = description => {
        if (submitOnce.isInFlight()) return
        setTask(current => ({ ...current, description }))
        setShowMoreOptionsModal(false)
    }

    const addDroppedFilesToDraft = (files, { quotaChecked = false } = {}) => {
        if (submitOnce.isInFlight()) return
        if (!quotaChecked) {
            // This module pulls in the user backend; load it only for an actual file drop.
            const { checkIsLimitedByTraffic } = require('../../../Premium/PremiumHelper')
            if (checkIsLimitedByTraffic(projectId)) return
        }
        const {
            appendTokensToDescription,
            createDraftAttachmentTokens,
        } = require('../../../TaskListView/TaskItem/TaskPresentation/taskFileDropHelper')
        const { tokens, uris } = createDraftAttachmentTokens(files)
        if (tokens.length === 0) return
        uris.forEach(uri => droppedObjectUrls.current.add(uri))
        setTask(current => ({
            ...current,
            description: appendTokensToDescription(current.description, tokens),
        }))
    }

    const onFilesDropped = files => addDroppedFilesToDraft(files)

    // The opener has already checked the traffic quota before opening this popup for a drop,
    // so checking again would show the limit modal twice. The ref keeps a re-run of the effect
    // (StrictMode, fast refresh) from appending the same files a second time.
    const initialFilesApplied = useRef(false)
    useEffect(() => {
        if (initialFilesApplied.current) return
        initialFilesApplied.current = true
        if (initialFiles && initialFiles.length > 0) addDroppedFilesToDraft(initialFiles, { quotaChecked: true })
    }, [])

    const submitDraft = createDraft => {
        const create = preparedTask => {
            if (onDraftSubmitted) onDraftSubmitted(preparedTask)
            return createDraft(preparedTask)
        }
        return submitOnce(() => {
            // Every local file URI generated by the attachment paths starts with `blob:`.
            // Ordinary task creation remains synchronous and avoids loading the upload tree.
            if (!task.description?.includes('blob:')) return create(task)
            const {
                hasDraftAttachments,
                resolveDraftAttachments,
            } = require('../../../TaskListView/TaskItem/TaskPresentation/taskFileDropHelper')
            if (!hasDraftAttachments(task.description)) return create(task)

            const { checkIsLimitedByTraffic } = require('../../../Premium/PremiumHelper')
            if (checkIsLimitedByTraffic(projectId)) {
                submitOnce.reset()
                return
            }

            setUploadingDraft(true)
            return resolveDraftAttachments(projectId, task.description)
                .catch(() => ({ description: task.description, failedCount: 1 }))
                .then(({ description, failedCount }) => {
                    // Keep successfully uploaded words in the draft for a retry. A failed local
                    // word must never reach Firestore, even when other uploads succeeded.
                    if (failedCount > 0) {
                        setTask(current => ({ ...current, description }))
                        alert(translate('Task attachment upload failed'))
                        submitOnce.reset()
                        return
                    }
                    return create({ ...task, description })
                })
                .finally(() => setUploadingDraft(false))
        })
    }

    const saveRecurrence = recurrence => {
        setTask({ ...task, recurrence })
        setShowRecurrenceModal(false)
        dispatch(hideFloatPopup())
    }

    const saveEstimation = value => {
        setTask({ ...task, estimations: { ...task.estimations, [OPEN_STEP]: value } })
        setShowMoreOptionsModal(false)
    }

    const setAutoEstimation = autoEstimation => {
        setTask({ ...task, autoEstimation })
    }

    const saveHighlight = (e, data) => {
        e?.preventDefault()
        e?.stopPropagation()
        setTask({ ...task, hasStar: data.color })
        setShowMoreOptionsModal(false)
    }

    const saveParentGoal = (goal, goalProjectId) => {
        const goalScopeProjectId = goal ? goal.projectId || goalProjectId || projectId : projectId
        const projectChanged = !!goal && (goalScopeProjectId !== projectId || automaticProject)
        const { loggedUser, loggedUserProjectsMap } = store.getState()
        const scopedTask = projectChanged ? applyProjectSwitchToDraft(task, loggedUser.uid) : task
        const parentGoalId = goal ? goal.id : null
        const parentGoalIsPublicFor = goal ? goal.isPublicFor : null
        const lockKey = goal && goal.lockKey ? goal.lockKey : ''
        setTask({ ...scopedTask, parentGoalId, parentGoalIsPublicFor, lockKey })
        setActiveGoal(goal)

        // A goal belongs to exactly one project. Selecting it therefore turns
        // even the Automatic option into an explicit project scope and keeps
        // the visible project row aligned with the Firestore path that will
        // receive the task.
        if (projectChanged) {
            setAutomaticProject(false)
            setProjectId(goalScopeProjectId)
            setSelectedProject(
                projects.find(project => project.id === goalScopeProjectId) ||
                    loggedUserProjectsMap[goalScopeProjectId] || { id: goalScopeProjectId }
            )
        }
        setShowParentGoalModal(false)
        return true
    }

    const savePrivacy = (isPrivate, isPublicFor) => {
        setTask({ ...task, isPrivate, isPublicFor })
        setShowPrivacyModal(false)
        dispatch(hideFloatPopup())
    }

    // DueDateModal invokes saveDueDateBeforeSaveTask as (task, date, isObserved) —
    // reading the first argument as the date stored the whole draft task object
    // under dueDate (found via the Typesense backfill's schema rejections).
    const saveDueDate = (taskFromModal, dueDate) => {
        if (dueDate !== undefined) setTask({ ...task, dueDate })
        setShowDueDateModal(false)
        dispatch(hideFloatPopup())
    }

    const setToBacklog = () => {
        setTask({ ...task, dueDate: Number.MAX_SAFE_INTEGER })
        setShowDueDateModal(false)
        dispatch(hideFloatPopup())
    }

    const saveAssignee = (user, observers) => {
        const { uid } = user
        const { loggedUser } = store.getState()

        const updatedTask = { ...task }
        if (uid) {
            updatedTask.userId = uid
            updatedTask.userIds = [uid]
            updatedTask.currentReviewerId = uid
            updatedTask.observersIds = observers.map(user => user.uid)
            updatedTask.creatorId = uid
        }
        updatedTask.suggestedBy =
            loggedUser.uid !== uid && !user.recorderUserId && !uid.startsWith(WORKSTREAM_ID_PREFIX)
                ? loggedUser.uid
                : null
        setTask(updatedTask)
        setShowAssigneeModal(false)
        dispatch(hideFloatPopup())
    }

    // Spread into the create payload: `{}` for a normally picked project, so a
    // task that was not created with "Automatic" carries no routing field at all
    // and the Cloud Function skips it without a read.
    const automaticProjectRoutingFields = () =>
        automaticProject ? { projectRouting: buildPendingProjectRouting({ hostProjectId: projectId }) } : {}

    const assignAndComment = (user, observers) =>
        submitDraft(preparedTask => {
            const { uid } = user
            const { loggedUser } = store.getState()
            closeModal(preparedTask)

            const updatedTask = { ...preparedTask }
            if (uid) {
                updatedTask.userId = uid
                updatedTask.userIds = [uid]
                updatedTask.currentReviewerId = uid
                updatedTask.observersIds = observers.map(user => user.uid)
                updatedTask.creatorId = uid
                updatedTask.suggestedBy =
                    loggedUser.uid !== uid && !user.recorderUserId && !uid.startsWith(WORKSTREAM_ID_PREFIX)
                        ? loggedUser.uid
                        : null
            }

            setTask(updatedTask)
            setShowAssigneeModal(false)
            dispatch(hideFloatPopup())

            if (expandTaskListIfNeeded) tryExpandTasksList(updatedTask)
            if (tryExpandTasksListInGoalWhenAddTask) tryExpandTasksListInGoalWhenAddTask(updatedTask)
            return createTaskWithService(
                {
                    projectId,
                    ...updatedTask,
                    ...automaticProjectRoutingFields(),
                },
                {
                    awaitForTaskCreation: true,

                    notGenerateMentionTasks: false,
                    notGenerateUpdates: false,
                }
            ).then(task => {
                dispatch(updateTaskSuggestedCommentModalData(true, projectId, task, task.extendedName))
                return task
            })
        })

    const delayClosePopup = () => {
        setTimeout(async () => {
            setShowRecurrenceModal(false)
            setShowPrivacyModal(false)
            setShowDueDateModal(false)
            setShowAssigneeModal(false)
            setShowParentGoalModal(false)
            setShowMoreOptionsModal(false)
            dispatch(hideFloatPopup())
        })
    }

    const createTask = trySetLinkedObjects => {
        // The empty-name check stays outside the guard so that pressing Enter on
        // an empty popup does not consume the single allowed submission.
        if (task.name.trim().length === 0) return

        return submitDraft(preparedTask => {
            closeModal(preparedTask)
            return persistNewTask(preparedTask).then(taskResult => {
                trySetLinkedObjects(taskResult)
                return {
                    ...taskResult,
                    id: taskResult.id,
                }
            })
        })
    }

    // The creation itself, shared by Enter/Done above and the background dictation below. It reads
    // only this render's state, props and the store, so it still works after the popup unmounted.
    const persistNewTask = preparedTask => {
        if (triggerWhenCreateTask) triggerWhenCreateTask()

        setShowInteractionBar && setShowInteractionBar(false)
        if (expandTaskListIfNeeded) tryExpandTasksList(preparedTask)
        if (tryExpandTasksListInGoalWhenAddTask) tryExpandTasksListInGoalWhenAddTask(preparedTask)

        // Use unified TaskService instead of old uploadNewTask
        return createTaskWithService(
            {
                projectId,
                name: preparedTask.name,
                description: preparedTask.description || '',
                userId: preparedTask.userId,
                dueDate: preparedTask.dueDate,
                isPrivate: preparedTask.isPrivate,
                observersIds: preparedTask.observersIds || [],
                estimations: preparedTask.estimations,
                recurrence: preparedTask.recurrence,
                parentId: preparedTask.parentId,
                linkBack: preparedTask.linkBack || '',
                genericData: preparedTask.genericData,
                parentGoalId: preparedTask.parentGoalId,
                // Pass through all other task properties
                ...preparedTask,
                // Last on purpose: the draft task never carries a routing
                // stamp, and only the picker's current state decides it.
                ...automaticProjectRoutingFields(),
            },
            {
                awaitForTaskCreation: true,

                notGenerateMentionTasks: false,
                notGenerateUpdates: false,
            }
        )
    }

    // PT-5425: a dictated task that could not be created in the background comes back in the
    // app-wide recovery popup (this popup is gone by then, and so may be its opener) with the draft
    // as it was at release — and with the dictated title once the transcript is known.
    const restoreDictatedDraft = draft =>
        openDictationTaskRecovery({ projectId, automaticProject, task: draft, modalTitle })

    // Creates `preparedTask` from a closed popup and reports a failure instead of swallowing it: the
    // popup is already gone, so an alert plus the restored draft is the only place left to say that
    // the task was not created. Never rejects.
    const persistDictatedTask = (preparedTask, onCreated) =>
        Promise.resolve()
            .then(() => {
                if (onDraftSubmitted) onDraftSubmitted(preparedTask)
                return persistNewTask(preparedTask)
            })
            .then(taskResult => {
                if (onCreated && taskResult) onCreated(taskResult)
                return taskResult
            })
            .catch(error => {
                console.error('[RichCreateTaskModal] Background dictated task creation failed', error)
                alert(translate('Task could not be created'))
                restoreDictatedDraft(preparedTask)
                return null
            })

    // PT-5424: a hold on the board's floating "+" closes this popup the moment it is released, and
    // the take is transcribed after that. The mic therefore cannot type the transcript in here and
    // press Enter; it hands the text to this function instead, which creates the task from this
    // popup's draft exactly as Enter would.
    const createDictatedTaskInBackground = text => {
        const dictated = typeof text === 'string' ? text.replace(/\s+/g, ' ').trim() : ''
        const extendedName = [(task.extendedName || '').trim(), dictated].filter(Boolean).join(' ')
        const name = TasksHelper.getTaskNameWithoutMeta(extendedName)
        if (!name || !name.trim()) return Promise.resolve(null)
        return persistDictatedTask({ ...task, extendedName, name })
    }
    if (pushToTalkHandoff?.setBackgroundSubmit) pushToTalkHandoff.setBackgroundSubmit(createDictatedTaskInBackground)

    // Read by `claimDictatedTaskInBackground`, which is entered from a DOM event (the mic release)
    // and therefore must not trust the closure of whichever render bound it.
    const latestDictationHostRef = useRef(null)
    latestDictationHostRef.current = { task, persistDictatedTask, restoreDictatedDraft }

    /**
     * PT-5425: a push-to-talk release on the title mic of THIS popup (not a hold handed over from
     * the floating "+", which PT-5424 covers above). Returns `null` to decline — the mic then keeps
     * the interactive insert-then-Enter path and the popup stays open — or the three hooks the mic
     * drives: `dismiss` right after the take is safely stopped, then exactly one of `submit` (with
     * the final title, composed at the caret by CustomTextInput3) or `onFailed`.
     *
     * @param {(taskResult: object, composed: object) => void} [onCreated] links mentioned objects
     */
    const claimDictatedTaskInBackground = onCreated => {
        if (submitOnce.isInFlight()) return null
        const {
            task: draft,
            persistDictatedTask: persist,
            restoreDictatedDraft: restore,
        } = latestDictationHostRef.current
        // Files dropped on the popup are still local `blob:` URLs, which this popup revokes when it
        // unmounts. Closing it now would destroy them before they are uploaded, so a draft with
        // files keeps the popup open and goes through the ordinary path with its upload step.
        if (draft.description?.includes('blob:')) return null

        let settle = () => {}
        const settled = new Promise(resolve => {
            settle = resolve
        })
        let finished = false
        const finish = () => {
            if (finished) return false
            finished = true
            settle()
            return true
        }
        return {
            dismiss: () => {
                // One task per release: Enter can no longer create a second one from this draft.
                submitOnce(() => settled)
                closeModal(draft)
            },
            submit: composed => {
                if (finished) return Promise.resolve(null)
                const extendedName = (composed?.extendedText || '').replace(/\r?\n|\r/g, '').trim()
                const name = TasksHelper.getTaskNameWithoutMeta(extendedName)
                if (!name || !name.trim()) {
                    finish()
                    restore(draft)
                    return Promise.resolve(null)
                }
                return persist({ ...draft, extendedName, name }, taskResult =>
                    onCreated?.(taskResult, composed)
                ).finally(finish)
            },
            onFailed: () => {
                if (finish()) restore(draft)
            },
        }
    }

    const expandTasks = () => {
        const { selectedProjectIndex, currentUser, smallScreenNavigation } = store.getState()

        const inSelectedProject = checkIfSelectedProject(selectedProjectIndex)
        if (inSelectedProject) {
            setPressedShowMoreMainSection(true)
        } else {
            const projectIndex = ProjectHelper.getProjectById(projectId)?.index
            const projectType = ProjectHelper.getTypeOfProject(currentUser, projectId)
            const actionsToDispatch = [
                setTasksArrowButtonIsExpanded(true),
                hideFloatPopup(),
                setSelectedSidebarTab(DV_TAB_ROOT_TASKS),
                switchProject(projectIndex),
                setSelectedTypeOfProject(projectType),
            ]

            if (smallScreenNavigation) actionsToDispatch.push(hideWebSideBar())

            dispatch(actionsToDispatch)
        }
    }

    const isCreatedInMainDate = dueDate => {
        const endDateDueDate = moment(dueDate).endOf('day').valueOf()
        return endDateDueDate === moment().endOf('day').valueOf()
    }

    const isNextTaskIsHidden = () => {
        const { loggedUser, filteredOpenTasksStore, currentUser } = store.getState()

        const dateIndex = 0
        const instanceKey = projectId + currentUser.uid

        const projectDateData = filteredOpenTasksStore[instanceKey]?.[dateIndex]

        const emptyGoalsAmount = (projectDateData?.[EMPTY_SECTION_INDEX] || []).length

        let inGoalsItemsAmount = emptyGoalsAmount
        let allItemsAmount = emptyGoalsAmount

        const mainTasksList = projectDateData?.[MAIN_TASK_INDEX] || []
        mainTasksList.forEach(goalTasksData => {
            // Ensure goalTasksData and goalTasksData[1] are valid before accessing length
            const tasksArray = goalTasksData?.[1]
            if (tasksArray && Array.isArray(tasksArray)) {
                if (goalTasksData[0] !== NOT_PARENT_GOAL_INDEX) {
                    inGoalsItemsAmount += tasksArray.length
                }
                allItemsAmount += tasksArray.length
            }
        })

        const isTemplateProject = loggedUser.templateProjectIds.includes(projectId)
        const nextTaskIsHidden = isTemplateProject
            ? loggedUser.numberTodayTasks <= allItemsAmount
            : loggedUser.numberTodayTasks <= inGoalsItemsAmount

        return nextTaskIsHidden
    }

    const tryExpandTasksList = task => {
        const {
            loggedUser,
            currentUser,
            loggedUserProjectsMap,
            selectedProjectIndex,
            myDayAllTodayTasks,
            administratorUser,
            projectUsers,
        } = store.getState()

        const inSelectedProject = checkIfSelectedProject(selectedProjectIndex)
        if (!inSelectedProject && loggedUser.showAllProjectsByTime) {
            const isLoggedUserTask = task.userId === loggedUser.uid
            const isWorkstreamTask = isWorkstream(task.userId)
            const isTodayTask = (isLoggedUserTask || isWorkstreamTask) && isCreatedInMainDate(task.dueDate)

            if (isTodayTask) {
                const tasksType = isLoggedUserTask ? TO_ATTEND_TASKS_MY_DAY_TYPE : WORKSTREAM_TASKS_MY_DAY_TYPE

                const tasks = myDayAllTodayTasks?.[projectId]?.[tasksType]?.tasks ?? []
                tasks.push({ ...task, projectId })

                const newMyDayAllTodayTasks = addProjectDataToMyDayData(
                    projectId,
                    tasksType,
                    isWorkstreamTask ? task.userId : '',
                    tasks,
                    {},
                    myDayAllTodayTasks
                )

                const { myDayOtherTasks } = processMyDayData(
                    loggedUser,
                    loggedUserProjectsMap,
                    newMyDayAllTodayTasks,
                    administratorUser.uid,
                    projectUsers
                )

                if (myDayOtherTasks.some(t => t.id === task.id)) {
                    expandTasks()
                }
            }
        } else {
            const inLoggedUserBoard = loggedUser.uid === currentUser.uid
            const isLoggedUserTask = task.userId === loggedUser.uid
            const cannotShowAllTasks = !!loggedUser.numberTodayTasks

            const needToExpand =
                cannotShowAllTasks &&
                inLoggedUserBoard &&
                isLoggedUserTask &&
                isCreatedInMainDate(task.dueDate) &&
                isNextTaskIsHidden()

            if (needToExpand) expandTasks()
        }
    }

    const setActiveGoalData = goal => {
        const isPublic = objectIsPublicForLoggedUser(goal)
        setActiveGoal(isPublic ? goal : null)
    }

    // PT-4745: the draft's project-scoped ids cannot survive a project change —
    // see projectSwitchDraft.js for which ones and why. Called BEFORE the new
    // project is committed so it never runs against a half-updated draft, and
    // only when the destination really differs: re-picking the project the popup
    // already opened on must not quietly drop the user's goal or assignee.
    const applyProjectSwitch = (nextProjectId, nextIsAutomatic) => {
        if (submitOnce.isInFlight()) return
        const unchanged = nextProjectId === projectId && !!nextIsAutomatic === !!automaticProject
        if (unchanged) return

        const { loggedUser } = store.getState()
        const switchedTask = applyProjectSwitchToDraft(task, loggedUser.uid)
        if (switchedTask === task) return

        setTask(switchedTask)
        // The goal chip is rendered from this, not from the draft, so it has to
        // be cleared with it or a dropped goal keeps showing in the popup.
        if (!switchedTask.parentGoalId) setActiveGoal(null)
    }

    useEffect(() => {
        const { parentGoalId } = task

        if (parentGoalId) {
            const watcherKey = v4()
            Backend.watchGoal(projectId, parentGoalId, watcherKey, setActiveGoalData)
            return () => {
                Backend.unwatch(projectId, watcherKey)
            }
        }
    }, [task.parentGoalId, projectId])

    useEffect(() => {
        if (showProjectSelector) {
            const { loggedUser, loggedUserProjectsMap, loggedUserProjects } = store.getState()

            const activeProjects = ProjectHelper.getActiveProjects2(loggedUserProjects, loggedUser)
            const guides = ProjectHelper.getGuideProjects(loggedUserProjects, loggedUser)

            const sortedProjects = [
                ...ProjectHelper.sortProjects(activeProjects, loggedUser.uid),
                ...ProjectHelper.sortProjects(guides, loggedUser.uid),
            ]

            setProjects(sortedProjects)
            // PT-4745: `MainModal` renders the switcher row only when it has a
            // selected project, so an unresolvable id used to HIDE the switcher
            // — the one outcome this task exists to remove. The popup was opened
            // on this project and will create the task in it either way, so fall
            // back to the bare id and keep the row (and the way out of it).
            setSelectedProject(
                automaticProject
                    ? { id: AUTOMATIC_PROJECT_OPTION }
                    : loggedUserProjectsMap[projectId] || (projectId ? { id: projectId } : null)
            )
        }
    }, [showProjectSelector])

    return (
        <CustomScrollView showsVerticalScrollIndicator={false}>
            {showSelectProjectModal ? (
                <SelectProjectModalInSearch
                    projectId={automaticProject ? AUTOMATIC_PROJECT_OPTION : projectId}
                    closePopover={() => {
                        setTimeout(() => {
                            setShowSelectProjectModal(false)
                        })
                    }}
                    projects={projects}
                    setSelectedProjectId={selectedProjectId => {
                        if (isAutomaticProjectOption(selectedProjectId)) {
                            const hostProjectId = getAutomaticHostProjectId()
                            applyProjectSwitch(hostProjectId, true)
                            setAutomaticProject(true)
                            setProjectId(hostProjectId)
                            setSelectedProject({ id: AUTOMATIC_PROJECT_OPTION })
                            return
                        }
                        applyProjectSwitch(selectedProjectId, false)
                        setAutomaticProject(false)
                        setProjectId(selectedProjectId)
                        setSelectedProject(
                            projects.find(project => project.id === selectedProjectId) || { id: selectedProjectId }
                        )
                    }}
                    showGuideTab={true}
                    showAutomaticProject={true}
                    positionInPlace={true}
                    widthStyle={widthStyle}
                />
            ) : showDueDateModal ? (
                <DueDateModal
                    task={task}
                    projectId={projectId}
                    closePopover={delayClosePopup}
                    delayClosePopover={delayClosePopup}
                    inEditTask={false}
                    saveDueDateBeforeSaveTask={saveDueDate}
                    setToBacklogBeforeSaveTask={setToBacklog}
                />
            ) : showRecurrenceModal ? (
                <RecurrenceModal
                    task={task}
                    projectId={projectId}
                    saveRecurrenceBeforeSaveTask={saveRecurrence}
                    closePopover={delayClosePopup}
                />
            ) : showPrivacyModal ? (
                <PrivacyModal
                    object={task}
                    objectType={FEED_TASK_OBJECT_TYPE}
                    projectId={projectId}
                    closePopover={delayClosePopup}
                    delayClosePopover={delayClosePopup}
                    savePrivacyBeforeSaveObject={savePrivacy}
                />
            ) : showParentGoalModal ? (
                <TaskParentGoalModal
                    activeGoal={activeGoal}
                    setActiveGoal={saveParentGoal}
                    projectId={projectId}
                    closeModal={delayClosePopup}
                    ownerId={task.userId}
                    notDelayClose={true}
                />
            ) : showMoreOptionsModal ? (
                <TaskMoreOptionModal
                    saveDescription={saveDescription}
                    saveEstimation={saveEstimation}
                    setAutoEstimation={setAutoEstimation}
                    saveHighlight={saveHighlight}
                    task={task}
                    projectId={projectId}
                    closeModal={delayClosePopup}
                />
            ) : showAssigneeModal ? (
                <AssigneeAndObserversModal
                    projectIndex={ProjectHelper.getProjectById(projectId)?.index}
                    object={task}
                    onSaveData={saveAssignee}
                    closePopover={delayClosePopup}
                    delayClosePopover={delayClosePopup}
                    inEditTask
                    updateTask={assignAndComment}
                />
            ) : (
                <MainModal
                    projectId={projectId}
                    closeModal={closeModal}
                    modalTitle={modalTitle}
                    task={task}
                    showAssigneeModal={showAssigneeModal}
                    showDueDate={showDueDate}
                    showRecurring={showRecurring}
                    showParentGoal={showParentGoal}
                    showPrivacy={showPrivacy}
                    showAssignee={showAssignee}
                    showMoreOptions={showMoreOptions}
                    showSelectProject={showSelectProject}
                    createTask={createTask}
                    setTask={setTask}
                    onFilesDropped={onFilesDropped}
                    uploadingDraft={uploadingDraft}
                    selectedProject={selectedProject}
                    activeGoal={activeGoal}
                    widthStyle={widthStyle}
                    pushToTalkHandoff={pushToTalkHandoff}
                    claimDictatedTaskInBackground={claimDictatedTaskInBackground}
                />
            )}
        </CustomScrollView>
    )
}
